import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import moment from 'moment';
import { get, getJson } from 'session';
import _ from 'lodash';
import Alert from 'react-s-alert';

import Pagination from 'modules/common/components/Pagination';
import { convertToTitleCase } from '../../../../helper';

import * as actions from '../actions'
import * as c from '../constants'

const CSVUploadContent = ({
  csvListing,
  getCSVListing,
  isLoading,
  pager,
  CSV_NAME,
  title,
}) => {
  const token = get('token') || '';
  const authProfile = getJson('profile') || {
    
  };
  const [file, setFile] = useState({});

  const fileHandler = e => setFile(e.target.files[0]);

  //  update to axios later / move to another file or hooks
  const postFormData = (url) => (formdata, onProgress) =>
    new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;
        // eslint-disable-next-line no-unused-vars
        xhr.addEventListener('timeout', (e) =>
          resolve({
            status: 400,
            message: 'Request Timeout, Please try again.',
          })
        );
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.onload = () => {
          try {
            const jsonResponse = JSON.parse(xhr.response);
            const response = {
              status: xhr.status, // jsonResponse.status,
              data: jsonResponse,
            };
            resolve(response);
          } catch (err) {
            reject(err);
          }
        };
        xhr.onerror = () => {
          const errRes = {
            data: false,
            message: 'Oops..Something went wrong.',
          };
          Alert.error(errRes);
          return resolve(errRes);
        };
        if (xhr.upload) {
          xhr.upload.onprogress = (evt) => {
            if (evt.lengthComputable) {
              const progress = Math.ceil((evt.loaded / evt.total) * 100);
              if (onProgress) {
                onProgress(progress);
              }
            }
          };
        }
        xhr.send(formdata);
      } catch (err) {
        reject(err);
      }
    });
  
    // upload csv
  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();
    try {
      data.append('file', file);
      data.append('subject', CSV_NAME);
      const res = await postFormData(`${process.env.REACT_APP_WS}${c.CSV_UPLOAD_LISTING}`)(data);
      const status = _.get(res, 'status')
      if (status >= 200 && status <= 299) {
        Alert.success(_.get(res, 'data.message'));
        getCSVListing({ subject: CSV_NAME }, () => {
          setFile({})
        })
      }
      if ((status >= 401 && status <= 599) || (status >= 300 && status <= 399)) {
        Alert.error(_.get(res, 'data.message'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }

    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  // download csv
  const downloadCSV = (id) => {
    const path = `${process.env.REACT_APP_WS}${c.CSV_UPLOAD_LISTING}/${id}/download_failed`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      bearer_token: token,
      email: _.get(authProfile, 'email'),
    });
    return `${path}?${params}`;
  };

  useEffect(() => {
    getCSVListing({ subject: CSV_NAME })
  }, [])

  // display status
  const formatStatusBadge = status => {
    // statuses: STARTED | FINISHED
    if (status === 'FINISHED') return <span className='bg-success px-2 rounded text-light'>{convertToTitleCase(status)}</span>

    return <span className='bg-warning px-2 rounded text-light'>{convertToTitleCase(status)}</span>
  }

  const handleChangePageUpload = (page) => {
    getCSVListing({ subject: CSV_NAME, page })
  };

  return (
    <div className="container-fluid card-section-content mt-4">
      <div className="bg-white p-4 my-4 border-none rounded shadow">
        <div className="header d-flex justify-content-between">
          {/* title */}
          <h2 className="font-weight-bold py-2">{title}</h2>
          {/* upload */}
          <div className="form-row">

            <div className="form-upload-container flex-column">
              <div className="form-group mt-1 d-flex justify-content-end">
                {isLoading && (
                  <i className="fa fa-spin fa-spinner my-auto mr-2" />
                )}
                <input
                  type="file"
                  className="btn btn-link input-upload"
                  onChange={fileHandler}
                />
                <button
                  type="button"
                  onClick={onUploadFile}
                  className="ml-2 btn btn-link button-upload cms-bg-color-primary cms-outline-primary"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* table */}
        <div className="table-scroll rounded">
          <table className="table table-sm table-hover" style={{ minWidth: '1200px' }}>
            {/* header */}
            <thead className="table-header">
              <tr className="billing-table-tr text-center">
                <th className="py-3 cms-text-primary cms-bg-color-primary-light">
                  Subject
                </th>
                <th className="py-3 cms-text-primary cms-bg-color-primary-light">
                  Date Uploaded
                </th>
                <th className="py-3 cms-text-primary cms-bg-color-primary-light">
                  File Name
                </th>
                <th className="py-3 cms-text-primary cms-bg-color-primary-light">
                  Failed Rows
                </th>
                <th className="py-3 cms-text-primary cms-bg-color-primary-light">
                  Success Rows
                </th>
                <th className="py-3 cms-text-primary cms-bg-color-primary-light">
                  Total Rows
                </th>
                <th className="py-3 cms-text-primary cms-bg-color-primary-light">
                  Status
                </th>
                <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                  Actions
                </th>
              </tr>
            </thead>
            {/* content */}
            <tbody className="table-details">
              {(_.isEmpty(csvListing) || !csvListing) ?  
                (
                  <tr>
                    <td colSpan={8} className="text-center py-5 h2">
                      {isLoading ?
                        <i className="fa fa-spin fa-spinner my-auto mr-2" /> : (
                          <>
                            <i className="fas fa-exclamation pr-2 pt-1" /> 
                            {`No Available Records.`}
                          </>  
                        )
                      }
                    </td>
                  </tr>
                ) : 
                csvListing?.map((item) => {
                const { subject, data_human, file_name, failed_rows, success_rows, total_rows, status } = _.get(item, "attributes")
                return (
                  <tr key={String(_.get(item, "id"))} className="billing-table-tr text-center">
                    <td className="py-3 align-middle">{subject || "--"}</td>
                    <td className="py-3 align-middle">{moment(data_human)?.format('MMM DD, YYYY') || "--"}</td>
                    <td className="py-3 align-middle">{file_name || "--"}</td>
                    <td className="py-3 align-middle">{failed_rows || "0"}</td>
                    <td className="py-3 align-middle">{success_rows || "0"}</td>
                    <td className="py-3 align-middle">{total_rows || "0"}</td>
                    <td className="py-3 align-middle">
                      {formatStatusBadge(status) || "--"}
                    </td>
                    <td className="py-3 align-middle">
                      <a
                        href={downloadCSV(_.get(item, "id"))}
                        hrefLang="en-us"
                        className="btn-blank cms-bg-color-primary cms-outline-primary border rounded p-2"
                        style={{ color: 'white' }}
                        tooltip='true'
                        title='download'
                      >
                        <i className='fa fa-print px-1 py-2' style={{ color: '#fff'}} />
                      </a>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        {/* pagination */}
        <div className="list-pagination">
          {pager.total_pages > 1 ? (
            <div className="d-flex justify-content-center text-center align-item-center">
              <Pagination
                data={pager}
                onChange={handleChangePageUpload}
              />
            </div>
          ) : ''}
        </div>
      </div>
    </div>
  )
}

CSVUploadContent.propTypes = {
  CSV_NAME: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  csvListing: PropTypes.instanceOf(Object).isRequired,
  getCSVListing: PropTypes.instanceOf(Function).isRequired,
  
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
}

const mapStateToProps = ({ api }, { location }) => ({
  permissions: getJson('permissions'),
  pathName: _.get(location, 'pathname'),
  csvListing: _.get(api, `${c.GET_CSV_LISTING}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_CSV_LISTING) > -1,
  pager: _.get(api, `${c.GET_CSV_LISTING}.pager`) || {},
})

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)])

export default enhance(CSVUploadContent);
